import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "xlsxFormIsOpen");
        Vue.set(state, "wikiIsOpen", false);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
        state.xlsxFormIsOpen = false;
        state.wikiIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.xlsxFormIsOpen = false;
        state.gridIsOpen = true;
        state.wikiIsOpen = false;
    },
    setXlsxFormOpen(state){
        state.xlsxFormIsOpen = true;
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.wikiIsOpen = false;
    },
    setXlsxFormClose(state){
        state.xlsxFormIsOpen = false;
        state.formIsOpen = false;
        state.gridIsOpen = true;
        state.wikiIsOpen = false;
    },
    setWikiOpen(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.xlsxFormIsOpen = false;
        state.wikiIsOpen = true;
    },
    setWikiClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
        state.xlsxFormIsOpen = false;
        state.wikiIsOpen = false;
    },
}
